var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-time"},[_vm._v(" "+_vm._s(_vm._f("dateFormat")(_vm.date,'d LLL yyyy'))+" "),(!_vm.hideTime)?_c('div',{staticClass:"small text-muted"},[_vm._v(" "+_vm._s(_vm._f("dateFormat")(_vm.date,'HH:mm'))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }